import { render, staticRenderFns } from "./RadioButtonBase.vue?vue&type=template&id=0851bd6a&scoped=true&"
import script from "./RadioButtonBase.vue?vue&type=script&lang=js&"
export * from "./RadioButtonBase.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonBase.vue?vue&type=style&index=0&id=0851bd6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851bd6a",
  null
  
)

export default component.exports